<script lang="ts">
interface Props {
  customColor?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'dark' | 'light' | 'dots';
}

const { customColor = '', size = 'small', variant = 'dark' }: Props = $props();
</script>

{#if variant === 'dots'}
  <span
    role="status"
    aria-live="polite"
    class={[
      'text-gray-7 inline-flex font-mono leading-none',
      {
        'text-xs': size === 'small',
        'text-sm': size === 'medium',
        'text-base': size === 'large',
      },
    ]}
  >
    <span
      aria-hidden="true"
      class="dots"
    ></span>
    <span class="sr-only">Loading</span>
  </span>
{:else}
  <div
    class={[
      'container flex size-4 items-center justify-center p-[1.5px]',
      {
        '': size === 'small',
        'scale-[1.125]': size === 'medium',
        'scale-[1.5]': size === 'large',
      },
    ]}
    aria-label="Progress spinner"
  >
    <div class="translate-x-[-6.5px]">
      {#each { length: 8 } as _, index (index)}
        <div
          style="
            transform: rotate({index * 45}deg);
            animation-delay: {index * 100}ms;
          "
          class={[
            'pill absolute -mt-[0.5px] h-px w-[3px] rounded-[1px]',
            {
              'bg-gray-8': !customColor && variant === 'dark',
              'bg-white': !customColor && variant === 'light',
              [`bg-${customColor}`]: customColor,
            },
          ]}
        ></div>
      {/each}
    </div>
  </div>
{/if}

<style>
.dots::before {
  content: '⠋';
  animation: dots-frames 800ms steps(1, end) infinite;
}

@keyframes dots-frames {
  0% {
    content: '⠋';
  }
  10% {
    content: '⠙';
  }
  20% {
    content: '⠹';
  }
  30% {
    content: '⠸';
  }
  40% {
    content: '⠼';
  }
  50% {
    content: '⠴';
  }
  60% {
    content: '⠦';
  }
  70% {
    content: '⠧';
  }
  80% {
    content: '⠇';
  }
  90% {
    content: '⠏';
  }
}

.pill {
  transform-origin: 6.5px 0.5px;
  animation: 0.8s linear 0s infinite fadeout;
}

@keyframes fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
</style>
